import React from 'react';
import { IValidationToastNotification } from '../../common';
import { IconType, MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';

export const FactoryCodeWarning = (props: IValidationToastNotification) => {
  return (
    <div className="w-[55rem] relative top-auto -bottom-[45rem] left-1/2 -translate-x-1/2">
      <MessageBar
        severity={TMessageBarSeverity.ERROR}
        onClose={props?.onClose}
        alertIcon={IconType.NewNextWarningSolid}
        dismissible
      >
        <h4 className="text-lg/[175%]">Feilmelding:</h4>
        <p className="text-base/[175%] font-semibold">
          Dette tilbudet inneholder feil grunndata i konfigurasjon og en fabrikkordre vil ikke kunne gjennomføres.
        </p>
        <p className="text-base/[175%] font-semibold">
          Velg enten et serienummer fra lagerliste, eller lage en ny tilbudslinje i CRM og åpne ny konfigurasjon i NEXT.
        </p>
      </MessageBar>
    </div>
  );
};
